let resumeData = {
  imagebaseurl: "https://rbhatia46.github.io/",
  name: "Tomás Edelcopp",
  role: "Full Stack Developer",
  roleDescription:
    "Full Stack Developer. Estudiante de la Tecnicatura Superior en Desarrollo de Software. Backend Developer en RethinkTheWay.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/edelcopp/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/tedelcopp",
      className: "fa fa-github",
    },
    {
      name: "gmail",
      url: "mailto:tomas.edelcopp@gmail.com",
      className: "fa fa-google-plus",
    },
    {
      name: "curriculum vitae",
      url: "https://drive.google.com/file/d/1GXfnt2vhmqyGO4VdT73GJkznhXybJUv5/view?usp=sharing",
      className: "fa fa-cloud-download",
    },
  ],
  aboutme1:
    "Mi nombre es Tomás Edelcopp. Nací en Buenos Aires, Argentina, y desde siempre sentí una fuerte curiosidad por la tecnología. En 2022 comencé a formarme de manera autodidacta y, al poco tiempo, completé un bootcamp intensivo en desarrollo web. Actualmente curso el segundo año de la Tecnicatura Superior en Desarrollo de Software, con el objetivo de seguir ampliando mis conocimientos y consolidar mi perfil profesional. Hoy trabajo como desarrollador backend en RethinkTheWay, donde participo en la integración de plataformas y el desarrollo de servicios que optimizan procesos de comunicación y gestión de datos. Esta experiencia ha sido fundamental para afianzar mis conocimientos y seguir creciendo dentro del área.",
  aboutme2:
    "Comencé mi camino profesional trabajando de forma freelance en proyectos personales como Finanzas Ya! y Darwin Studio Code, donde pude aplicar lo aprendido de forma práctica y asumir cada etapa del desarrollo por mi cuenta. Estas experiencias fueron clave para desarrollar autonomía, adaptarme a distintos contextos y fortalecer mis habilidades blandas, especialmente en la comunicación con clientes, la gestión de requerimientos y la organización del trabajo. Me interesa seguir tomando desafíos freelance, adaptándome a distintos entornos y tecnologías, y enfrentando proyectos diversos que me permitan seguir aprendiendo, incorporar nuevas herramientas y aportar valor desde mi lugar en equipos colaborativos enfocados en soluciones estables y escalables.",
  aboutme3:
    "Hoy trabajo como desarrollador backend en RethinkTheWay, donde participo en la integración de plataformas y el desarrollo de servicios que optimizan procesos de comunicación y gestión de datos. Esta experiencia ha sido fundamental para afianzar mis conocimientos y seguir creciendo dentro del área.",
  address: "📍 Buenos Aires, Argentina.",
  website: "tomas.edelcopp@gmail.com",
  education: [
    {
      UniversityName: "IFTS Nº18",
      specialization: "Tecnicatura Superior en Desarrollo de Software",
      MonthOfPassing: "Marzo",
      YearOfPassing: "2024",
    },
    {
      UniversityName: "Henry",
      specialization: "Full Stack Developer",
      MonthOfPassing: "Julio",
      YearOfPassing: "2023",
    },
    {
      UniversityName: "UTN.BA",
      specialization: "Marketing Digital  & Social Media",
      MonthOfPassing: "Noviembre",
      YearOfPassing: "2020",
    },
  ],
  work: [
    {
      CompanyName: "ReThinkTheWay",
      specialization: "Desarrollador Backend",
      MonthOfLeaving: "Abril",
      YearOfLeaving: "2025",
      Achievements:
        "Responsable del diseño e implementación para centralizar la comunicación de la empresa. Desarrollé una integración que unifica WhatsApp (a través de Baileys), buzones de correo corporativos y Evolution API con Chatwoot, lo que permite gestionar todos los mensajes en un único entorno. Además, automatizo servicios con Docker, administro servidores Linux y gestiono bases de datos PostgreSQL. Participo en la configuración y mantenimiento de la infraestructura en Oracle Cloud. Actualmente colaboro en el desarrollo y personalización del sitio web de la empresa en WordPress, aplicando diseños extraídos de Figma.",
    },
    {
      CompanyName: "GAOTek Inc.",
      specialization: "Web Developer",
      MonthOfLeaving: "Marzo",
      YearOfLeaving: "2025",
      Achievements:
        "Durante esta pasantía, colaboré en el desarrollo y creación de sitios web utilizando WordPress y WooCommerce, trabajando sobre requerimientos definidos por la empresa. También participé en la carga y administración de productos para la base de datos del e-commerce, asegurando una presentación clara y organizada del catálogo. Mantuve una comunicación fluida con el equipo a través de reuniones semanales en inglés, donde compartía avances, recibía retroalimentación y coordinaba los siguientes pasos. Esta experiencia fortaleció mis habilidades en desarrollo web, gestión de contenido y trabajo colaborativo en un entorno profesional e internacional.",
    },
    {
      CompanyName: "Frelance",
      specialization: "Desarrollador Autonomo",
      MonthOfLeaving: "Noviembre",
      YearOfLeaving: "2024",
      Achievements:
        "Diseño y desarrollo sitios web en WordPress y a medida en código, adaptados a las necesidades de cada proyecto. Participo desde la etapa inicial de planificación hasta la entrega final. Trabajo con personalización de temas y plugins. También colaboro en la carga de contenido, optimización visual y puesta en marcha del sitio. Mantengo una comunicación fluida con cada cliente o equipo de trabajo durante todas las etapas",
    },
  ],

  portfolio: [
    {
      name: "Medapp",
      description:
        "Desarrollé Medapp, una aplicación para la gestión de citas médicas y acceso a información de salud, con el objetivo de optimizar la experiencia del usuario y garantizar un alto rendimiento. Utilicé Next.js para el frontend, junto con Tailwind CSS para una estilización eficiente, React Hot Toast para notificaciones dinámicas y React Lucide para iconografía clara y funcional. La aplicación cuenta con una navegación optimizada mediante componentes reutilizables y estrategias de carga inteligente. En el backend, implementé una arquitectura de tres capas con Node.js y Express, estructurando controladores, servicios y acceso a datos para un código modular y escalable. Además, gestioné la base de datos con DBeaver, optimizando consultas y diseñando endpoints eficientes para mejorar la comunicación entre el servidor y el cliente.",
      imgurl: require("./images/Medapp - Project.png"),
      target: "_blank",
      urlgithub: "https://github.com/tedelcopp/MedApp-FrontEnd---Project",
      urldeploy: "https://themedapp.vercel.app/",
      stack:
        "NextJS | TypeScript | Tailwind CSS | MySQL | React Hot Toast | React Lucide | Node.js | Express | Sequelize | DBeaver.",
    },
    {
      name: "Finanzas Ya!",
      description:
        "Realicé una optimización para el equipo de Finanzas Ya! como parte de un proyecto freelance en WordPress. Mi trabajo se centró principalmente en actualizar todos los componentes del sitio web, asegurando su correcto funcionamiento y compatibilidad con las últimas versiones de WordPress, plugins y tecnologías asociadas. Además, rediseñé varias secciones clave del sitio para darles un aspecto más sofisticado y moderno, mejorando tanto la estética como la experiencia del usuario. Estos cambios incluyeron una revisión de la estructura y el diseño de las páginas, buscando siempre la armonía entre funcionalidad y visualización. Las mejoras implementadas lograron que el sitio web transmitiera una imagen más profesional y acorde a las necesidades y expectativas del cliente, resultando en una mayor satisfacción del mismo.",
      imgurl: require("./images/Finanzas Ya - Project.png"),
      target: "_blank",
      urlgithub: "_blank",
      urldeploy: "https://finanzasya.com.ar/",
      stack: "WordPress.",
    },
    {
      name: "Darwin Studio Code",
      description:
        "Desarrollé una Landing Page para una empresa de servicios web utilizando Next.js, con el objetivo de afianzar mis conocimientos en esta tecnología y mejorar la experiencia de usuario. Este proyecto cuenta con un diseño moderno y una estructura de navegación sencilla, permitiendo a los visitantes encontrar la información de manera rápida y eficiente. Implementé Tailwind CSS para estilizar la interfaz, React Hot Toast para notificaciones y React Lucide para iconografía, logrando una experiencia visual atractiva e interactiva. Además, incorporé botones de acción estratégicos para optimizar la conversión y la interacción del usuario.",
      imgurl: require("./images/Darwin Studio Code - Project.png"),
      target: "_blank",
      urlgithub: "https://github.com/tedelcopp/Darwin-Studio-Code---Project",
      urldeploy: "https://darwinstudiocode.vercel.app/",
      stack: "Next.js | React | Tailwind CSS | React Hot Toast | React Lucide.",
    },
    {
      name: "PPR Consultoría",
      description:
        "Desarrollé una Landing Page para una empresa de servicios web utilizando Next.js, con el objetivo de afianzar mis conocimientos en esta tecnología y mejorar la experiencia de usuario. Este proyecto cuenta con un diseño moderno y una estructura de navegación sencilla, permitiendo a los visitantes encontrar la información de manera rápida y eficiente. Implementé Tailwind CSS para estilizar la interfaz, React Hot Toast para notificaciones y React Lucide para iconografía, logrando una experiencia visual atractiva e interactiva. Además, incorporé botones de acción estratégicos para optimizar la conversión y la interacción del usuario.",
      imgurl: require("./images/PPR Consultoria Project.png"),
      target: "_blank",
      urlgithub: "https://github.com/tedelcopp/Darwin-Studio-Code---Project",
      urldeploy: "https://pprconsultoria.com/",
      stack: "WordPress | PHP | Elementor | JavaScript | HTML | CSS.",
    },
  ],
};

export default resumeData;
